module.exports = __webpack_public_path__ + "static/media/exit_popup_icon.e3c21ffe.svg";